import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import axios from "axios";
import { UserInfo } from "../../../context";
import MerchantLayout from "../../layout/MerchantLayout";
import { AuditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import MerchantProductConsumption from "./MerchantProductConsumption";
import ProductInfo from "../../commissary/products/ProductInfo";

const MerchantProducts = () => {
  const [productList, setProductList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [productInfoDrawer, setProductInfoDrawer] = useState(false);
  const [search, setSearch] = useState("");

  const calculateAvailability = (data) => {
    var emptyArray = [];
    for (let i = 0; i < data.productsprodrawused.length; i++) {
      emptyArray.push(
        parseFloat(data.productsprodrawused[i].productsaverawproduct.quantity) /
          parseFloat(data.productsprodrawused[i].consumption)
      );
    }
    var min = Math.min.apply(Math, emptyArray);
    return parseInt(min).toFixed(0);
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Price",
      dataIndex: "price",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Available",
      align: "right",
      render: (text, record) => <p>{calculateAvailability(text)}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: window.innerWidth > 575 ? "auto" : 90 }}>
          <Tooltip title="Product Info">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setProductInfoDrawer(true);
              }}
              icon={<InfoCircleOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>

          <Tooltip title="Consumption Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getProductList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-list", { params })
      .then((response) => {
        const data = response.data;
        setProductList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getProductList();
  }, [getProductList]);

  const searchable = productList.data.filter((data) => {
    return data.product.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <MerchantLayout>
      <div style={{ overflowX: "auto" }}>
        <div style={{ marginBottom: 10 }}>
          <Input
            placeholder="Search product"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {productInfoDrawer && (
        <ProductInfo
          open={productInfoDrawer}
          close={() => setProductInfoDrawer(false)}
          selectedData={selectedData}
          module={"merchant"}
          rerun={() => getProductList()}
        />
      )}

      {openDrawer && (
        <MerchantProductConsumption
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          selectedData={selectedData}
        />
      )}
    </MerchantLayout>
  );
};

export default MerchantProducts;
